import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import Slider from "react-slick";

export default function CustomizedSlider({
  slidesData,
  paddingBottom = false,
  withLightbox = false,
  withDescription = true,
  service,
  children,
}) {
  const [toggler, setToggler] = useState(false);
  const [activeImage, setActiveImage] = useState(1);
  const [images, setImages] = useState(slidesData.map((slide) => slide.imgSrc));

  return (
    <>
      <section
        id="blog"
        className={`blog-area p-relative fix ${paddingBottom || "pb-5"}`}
      >
        <div className="container">
          <div className="row align-items-center justify-content-center pt-5">
            <div className="col-lg-7 centered-column">
              <div
                className="section-title center-align mb-50 text-center wow fadeInDown animated"
                data-animation="fadeInDown"
                data-delay=".4s"
              >
                {children}
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-12 col-md-12">
                <Slider className="slider-about" {...service}>
                  {slidesData.map((slide, index) => {
                    return (
                      <Slide
                        key={index}
                        title={slide.title}
                        description={slide.description}
                        imgSrc={slide.imgSrc}
                        withLightbox={withLightbox}
                        onClick={() => {
                          if (withLightbox) {
                            setToggler(!toggler);
                            setActiveImage(index + 1);
                          }
                        }}
                        withDescription={withDescription}
                      ></Slide>
                    );
                  })}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section>
      {withLightbox && (
        <FsLightbox toggler={toggler} sources={images} slide={activeImage} />
      )}
    </>
  );
}

const Slide = ({
  title,
  description,
  imgSrc,
  withLightbox = false,
  onClick,
  withDescription = true,
}) => {
  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <div
        className="single-post2 hover-zoomin mb-30 wow fadeInUp animated"
        data-animation="fadeInUp"
        data-delay=".4s"
        style={{ width: "100%", margin: "0 7px" }}
      >
        <div className="blog-thumb2">
          <div
            to="#"
            onClick={onClick}
            className={withLightbox ? "pointer-on-hover" : ""}
            style={{ overflow: "hidden" }}
          >
            <img className="custom-slider-img" src={imgSrc} alt="img" style={{ width: "100%"}} />
          </div>
        </div>
        {withDescription && (
          <div className="blog-content2" style={{ width: "100%" }}>
            <h4>{title}</h4>
            <p>{description}</p>
          </div>
        )}
      </div>
    </div>
  );
};
